import React from 'react';

const ToggleHeaderBtn = props => {
  return (
    <div
      onClick={() => props.toggleHeaderVisible()}
      style={{
        position: 'absolute',
        bottom: 110,
        right: 30,
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#fff',
        color: '#333',
        WebkitBoxShadow: '2px 3px 5px 0px rgba(0,0,0,0.19)',
        MozBoxShadow: '2px 3px 5px 0px rgba(0,0,0,0.19)',
        boxShadow: '2px 3px 5px 0px rgba(0,0,0,0.19)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10,
      }}>
      <img
        style={{
          width: 20,
          height: 20,
        }}
        alt="locate"
        src={props.headerVisible ? require('../../assets/icons/open-map.png') : require('../../assets/icons/close-map.png')}
      />
    </div>
  );
};

export default ToggleHeaderBtn;
